/** The part of a react-navigation navigator state that names its focused route. */
export type FocusedRouteState = {
  readonly index: number;
  readonly routes: readonly { readonly name: string }[];
};

/**
 * The name of the navigator's focused route. react-navigation guarantees `routes[index]` exists
 * for a mounted navigator, so a missing entry is a corrupted state, not "no route": throw instead
 * of reporting `null` (which reads as "nothing focused" and silently mis-highlights the chrome).
 */
export function getFocusedRouteName(state: FocusedRouteState): string {
  const route = state.routes[state.index];
  if (route === undefined) {
    throw new Error(
      `Navigator state has no focused route: index ${state.index} of ${state.routes.length} routes`,
    );
  }
  return route.name;
}
